import React from "react";
import styled from "@emotion/styled";

const Icon = styled.span`
  padding-right: 1rem;
`;

const PathStroke = styled.path`
  stroke: ${({ isActive }) => (isActive ? "#C7A878" : "#C4C4C4")};
`;

const PathFill = styled.path`
  fill: ${({ isActive }) => (isActive ? "#C7A878" : "#C4C4C4")};
`;

export const DashboardIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathFill
        isActive={isActive}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM14.7692 8C14.7692 4.26146 11.7385 1.23077 8 1.23077C4.26146 1.23077 1.23077 4.26146 1.23077 8C1.23077 11.7385 4.26146 14.7692 8 14.7692C11.7385 14.7692 14.7692 11.7385 14.7692 8ZM7.02079 6.1505C7.31295 5.9955 7.64622 5.90769 8 5.90769C9.15555 5.90769 10.0923 6.84445 10.0923 8C10.0923 9.15555 9.15555 10.0923 8 10.0923C6.84445 10.0923 5.90769 9.15555 5.90769 8C5.90769 7.64622 5.9955 7.31295 6.1505 7.02079L4.1187 4.98899C3.87838 4.74867 3.87838 4.35903 4.1187 4.1187C4.33232 3.90508 4.66392 3.88135 4.90376 4.0475L4.98899 4.1187L7.02079 6.1505ZM8.86154 8C8.86154 7.52419 8.47581 7.13846 8 7.13846C7.52419 7.13846 7.13846 7.52419 7.13846 8C7.13846 8.47581 7.52419 8.86154 8 8.86154C8.47581 8.86154 8.86154 8.47581 8.86154 8Z"
      />
    </svg>
  </Icon>
);

export const RateSheetIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathFill
        isActive={isActive}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01538 0H0.615385C0.275517 0 0 0.275517 0 0.615385V7.01538C0 7.17859 0.064835 7.33512 0.180242 7.45053L8.54947 15.8198C8.7898 16.0601 9.17943 16.0601 9.41976 15.8198L15.8198 9.41976C16.0601 9.17943 16.0601 8.7898 15.8198 8.54947L7.45053 0.180242C7.33512 0.064835 7.17859 0 7.01538 0ZM6.76135 1.23077L14.5152 8.98462L8.98462 14.5152L1.23077 6.76135V1.23077H6.76135ZM5.04615 4.06154C5.04615 4.60533 4.60533 5.04615 4.06154 5.04615C3.51775 5.04615 3.07692 4.60533 3.07692 4.06154C3.07692 3.51775 3.51775 3.07692 4.06154 3.07692C4.60533 3.07692 5.04615 3.51775 5.04615 4.06154Z"
      />
    </svg>
  </Icon>
);

export const FAQIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathStroke
        isActive={isActive}
        d="M8.35 4.5C8.35 4.6933 8.1933 4.85 8 4.85C7.8067 4.85 7.65 4.6933 7.65 4.5C7.65 4.3067 7.8067 4.15 8 4.15C8.1933 4.15 8.35 4.3067 8.35 4.5Z"
        strokeWidth="1.3"
      />
      <PathStroke
        isActive={isActive}
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M8 12V8"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const OrdersIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathFill
        isActive={isActive}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.19333 0.524448C3.14937 0.2277 2.89359 0 2.58462 0H0.615385L0.524448 0.00667235C0.2277 0.0506258 0 0.306414 0 0.615385L0.00667235 0.706322C0.0506258 1.00307 0.306414 1.23077 0.615385 1.23077H1.96923V10.4615L1.9759 10.5525C2.01986 10.8492 2.27565 11.0769 2.58462 11.0769H15.3846L15.4756 11.0703C15.7723 11.0263 16 10.7705 16 10.4615L15.9933 10.3706C15.9494 10.0739 15.6936 9.84615 15.3846 9.84615H3.2V0.615385L3.19333 0.524448ZM4.06154 11.8154C2.90599 11.8154 1.96923 12.7521 1.96923 13.9077C1.96923 15.0632 2.90599 16 4.06154 16C5.21709 16 6.15385 15.0632 6.15385 13.9077C6.15385 12.7521 5.21709 11.8154 4.06154 11.8154ZM4.06154 13.0462C4.53735 13.0462 4.92308 13.4319 4.92308 13.9077C4.92308 14.3835 4.53735 14.7692 4.06154 14.7692C3.58572 14.7692 3.2 14.3835 3.2 13.9077C3.2 13.4319 3.58572 13.0462 4.06154 13.0462ZM11.8154 13.9077C11.8154 12.7521 12.7521 11.8154 13.9077 11.8154C15.0632 11.8154 16 12.7521 16 13.9077C16 15.0632 15.0632 16 13.9077 16C12.7521 16 11.8154 15.0632 11.8154 13.9077ZM14.7692 13.9077C14.7692 13.4319 14.3835 13.0462 13.9077 13.0462C13.4319 13.0462 13.0462 13.4319 13.0462 13.9077C13.0462 14.3835 13.4319 14.7692 13.9077 14.7692C14.3835 14.7692 14.7692 14.3835 14.7692 13.9077ZM14.4 0.984615H5.53846C5.19859 0.984615 4.92308 1.26013 4.92308 1.6V7.50769C4.92308 7.84756 5.19859 8.12308 5.53846 8.12308H14.4C14.7399 8.12308 15.0154 7.84756 15.0154 7.50769V1.6C15.0154 1.26013 14.7399 0.984615 14.4 0.984615ZM13.7846 2.21538V6.89231H6.15385V2.21538H13.7846Z"
      />
    </svg>
  </Icon>
);

export const CardsIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathStroke
        isActive={isActive}
        d="M4.5 10.5H7.5"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M12.5 10.5H13.5"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M16.5 6.5H1.5"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M15.5 13.5H2.5C1.948 13.5 1.5 13.052 1.5 12.5V3.5C1.5 2.948 1.948 2.5 2.5 2.5H15.5C16.052 2.5 16.5 2.948 16.5 3.5V12.5C16.5 13.052 16.052 13.5 15.5 13.5Z"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const LiabilitiesIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathFill
        isActive={isActive}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.615385 1H15.3846C15.7245 1 16 1.27491 16 1.61404V4.5614C16 4.90053 15.7245 5.17544 15.3846 5.17544H0.615385C0.275517 5.17544 0 4.90053 0 4.5614V1.61404C0 1.27491 0.275517 1 0.615385 1ZM14.7692 3.94737V2.22807H1.23077V3.94737H14.7692ZM13.4154 5.91228C13.7244 5.91228 13.9801 6.13948 14.0241 6.43558L14.0308 6.52632V14.386C14.0308 14.6943 13.8031 14.9495 13.5063 14.9933L13.4154 15H2.58462C2.27565 15 2.01986 14.7728 1.9759 14.4767L1.96923 14.386V6.52632C1.96923 6.18719 2.24475 5.91228 2.58462 5.91228C2.89359 5.91228 3.14937 6.13948 3.19333 6.43558L3.2 6.52632V13.7719H12.8V6.52632C12.8 6.21802 13.0277 5.9628 13.3244 5.91894L13.4154 5.91228ZM10.4615 6.89474H5.53846C5.19859 6.89474 4.92308 7.16965 4.92308 7.50877V10.4561C4.92308 10.7953 5.19859 11.0702 5.53846 11.0702H10.4615C10.8014 11.0702 11.0769 10.7953 11.0769 10.4561V7.50877C11.0769 7.16965 10.8014 6.89474 10.4615 6.89474ZM9.84615 8.12281V9.8421H6.15385V8.12281H9.84615Z"
      />
    </svg>
  </Icon>
);

export const PaymentsIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathFill
        isActive={isActive}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9933 0.524448C15.9494 0.2277 15.6936 0 15.3846 0H3.56923L3.47829 0.00667235C3.18155 0.0506258 2.95385 0.306414 2.95385 0.615385V10.4615L2.96052 10.5525C3.00447 10.8492 3.26026 11.0769 3.56923 11.0769L3.66017 11.0703C3.95692 11.0263 4.18462 10.7705 4.18462 10.4615V1.23077H14.7692V13.4154L14.763 13.5458C14.6975 14.2327 14.1195 14.7692 13.4154 14.7692C12.6673 14.7692 12.0615 14.1635 12.0615 13.4154V12.4308C12.0615 12.0909 11.786 11.8154 11.4462 11.8154H0.615385C0.275517 11.8154 0 12.0909 0 12.4308V13.4154C0 14.8433 1.15675 16 2.58462 16H13.4154C14.8433 16 16 14.8433 16 13.4154V0.615385L15.9933 0.524448ZM13.0462 4.55385C13.0462 4.21398 12.7706 3.93846 12.4308 3.93846H6.52308L6.43214 3.94513C6.13539 3.98909 5.90769 4.24488 5.90769 4.55385C5.90769 4.89371 6.18321 5.16923 6.52308 5.16923H12.4308L12.5217 5.16256C12.8185 5.11861 13.0462 4.86282 13.0462 4.55385ZM13.0462 7.50769C13.0462 7.16782 12.7706 6.89231 12.4308 6.89231H6.52308L6.43214 6.89898C6.13539 6.94293 5.90769 7.19872 5.90769 7.50769C5.90769 7.84756 6.18321 8.12308 6.52308 8.12308H12.4308L12.5217 8.1164C12.8185 8.07245 13.0462 7.81666 13.0462 7.50769ZM10.8359 13.5789L10.8308 13.4154V13.0462H1.23077V13.4154C1.23077 14.1195 1.76732 14.6975 2.45416 14.763L2.58462 14.7692H11.2138C10.9961 14.415 10.8628 14.0114 10.8359 13.5789Z"
      />
    </svg>
  </Icon>
);

export const PaymentMethodsIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathStroke
        isActive={isActive}
        d="M12 12.5C12.8284 12.5 13.5 11.8284 13.5 11C13.5 10.1716 12.8284 9.5 12 9.5C11.1716 9.5 10.5 10.1716 10.5 11C10.5 11.8284 11.1716 12.5 12 12.5Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M1.5 3.5V14.5C1.5 15.0304 1.71071 15.5391 2.08579 15.9142C2.46086 16.2893 2.96957 16.5 3.5 16.5H16.5V5.5H3.5C2.96957 5.5 2.46086 5.28929 2.08579 4.91421C1.71071 4.53914 1.5 4.03043 1.5 3.5V3.5ZM1.5 3.5C1.5 2.96957 1.71071 2.46086 2.08579 2.08579C2.46086 1.71071 2.96957 1.5 3.5 1.5H12.5V3.5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const ContactUsIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathStroke
        isActive={isActive}
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M9 12.5C10.933 12.5 12.5 10.933 12.5 9C12.5 7.067 10.933 5.5 9 5.5C7.067 5.5 5.5 7.067 5.5 9C5.5 10.933 7.067 12.5 9 12.5Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M11.474 6.52601L14.303 3.69701"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M11.474 11.474L14.303 14.303"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M6.52602 11.474L3.69702 14.303"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M6.52602 6.52601L3.69702 3.69701"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const UploadSpreadsheetIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <PathStroke
        isActive={isActive}
        d="M5.5 4.5L8.5 1.5L11.5 4.5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M8.5 1.5V11.5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <PathStroke
        isActive={isActive}
        d="M11.5 7.5H14.5L15.5 16.5H1.5L2.5 7.5H5.5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export const FacebookIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.02293 16L6 9H3V6H6V4C6 1.3008 7.67151 0 10.0794 0C11.2328 0 12.2241 0.08587 12.5129 0.12425V2.94507L10.843 2.94583C9.53343 2.94583 9.27987 3.5681 9.27987 4.48124V6H13L12 9H9.27986V16H6.02293Z"
        fill="#C4C4C4"
      />
    </svg>
  </Icon>
);

export const TwitterIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 3C15.4 3.3 14.8 3.4 14.1 3.5C14.8 3.1 15.3 2.5 15.5 1.7C14.9 2.1 14.2 2.3 13.4 2.5C12.8 1.9 11.9 1.5 11 1.5C9.3 1.5 7.8 3 7.8 4.8C7.8 5.1 7.8 5.3 7.9 5.5C5.2 5.4 2.7 4.1 1.1 2.1C0.8 2.6 0.7 3.1 0.7 3.8C0.7 4.9 1.3 5.9 2.2 6.5C1.7 6.5 1.2 6.3 0.7 6.1C0.7 7.7 1.8 9 3.3 9.3C3 9.4 2.7 9.4 2.4 9.4C2.2 9.4 2 9.4 1.8 9.3C2.2 10.6 3.4 11.6 4.9 11.6C3.8 12.5 2.4 13 0.8 13C0.5 13 0.3 13 0 13C1.5 13.9 3.2 14.5 5 14.5C11 14.5 14.3 9.5 14.3 5.2C14.3 5.1 14.3 4.9 14.3 4.8C15 4.3 15.6 3.7 16 3Z"
        fill="#C4C4C4"
      />
    </svg>
  </Icon>
);

export const YoutubeIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8 4.8C15.6 3.5 15 2.6 13.6 2.4C11.4 2 8 2 8 2C8 2 4.6 2 2.4 2.4C1 2.6 0.3 3.5 0.2 4.8C0 6.1 0 8 0 8C0 8 0 9.9 0.2 11.2C0.4 12.5 1 13.4 2.4 13.6C4.6 14 8 14 8 14C8 14 11.4 14 13.6 13.6C15 13.3 15.6 12.5 15.8 11.2C16 9.9 16 8 16 8C16 8 16 6.1 15.8 4.8ZM6 11V5L11 8L6 11Z"
        fill="#C4C4C4"
      />
    </svg>
  </Icon>
);

export const LinkedinIcon = ({ isActive }) => (
  <Icon>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M15.3 0H0.7C0.3 0 0 0.3 0 0.7V15.4C0 15.7 0.3 16 0.7 16H15.4C15.8 16 16.1 15.7 16.1 15.3V0.7C16 0.3 15.7 0 15.3 0ZM4.7 13.6H2.4V6H4.8V13.6H4.7ZM3.6 5C2.8 5 2.2 4.3 2.2 3.6C2.2 2.8 2.8 2.2 3.6 2.2C4.4 2.2 5 2.8 5 3.6C4.9 4.3 4.3 5 3.6 5ZM13.6 13.6H11.2V9.9C11.2 9 11.2 7.9 10 7.9C8.8 7.9 8.6 8.9 8.6 9.9V13.7H6.2V6H8.5V7C8.8 6.4 9.6 5.8 10.7 5.8C13.1 5.8 13.5 7.4 13.5 9.4V13.6H13.6Z"
          fill="#C4C4C4"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);
